module.exports = __webpack_public_path__ + "static/1-b77267e839e04b3f19429401e41799a9.jpg";